import MwcApplicationHelper from './mwc-application-helper';

MwcApplicationHelper.initializeMwc();
